module.exports = __webpack_public_path__ + "static/media/bkg-wall-e-01.9bc6b994.jpg";